export interface IApplicationDefinitionSummary {
  id: string;
  title: string;
  hasExpired: boolean;
  isArchived: boolean;
}
export class ApplicationDefinitionSummary implements IApplicationDefinitionSummary {
  public id: string;
  public title: string;
  public deadline: Date;
  public hasExpired: boolean;
  public requestUri: string;
  public formType: string;
  public isArchived: boolean;

  constructor() {}

  public static parse(data: any): ApplicationDefinitionSummary {
    if (!data) return null;

    let application = new ApplicationDefinitionSummary();
    Object.assign(application, data);

    return application;
  }
}
